import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { COLLECTIONS } from "@/data/photos";

const LABELS = {
  it: {
    kicker: "Le Collezioni",
    hint: "Tre sguardi in bianco e nero",
    works: "scatti",
    open: "Apri",
    contactTitle: "Contatti",
    contactSub: "Per collaborazioni, commissioni, mostre",
    contactCta: "Scrivimi",
  },
  en: {
    kicker: "The Collections",
    hint: "Three ways of looking in black & white",
    works: "works",
    open: "Open",
    contactTitle: "Contact",
    contactSub: "For commissions, collaborations, exhibitions",
    contactCta: "Write me",
  },
};

function CollectionTile({ collection, labels, index }) {
  const { lang } = useLang();
  const title = lang === "en" ? collection.titleEn : collection.titleIt;
  const subtitle = lang === "en" ? collection.subtitleEn : collection.subtitleIt;
  const cover = collection.photos[0];
  return (
    <Link
      to={`/collezione/${collection.slug}`}
      data-testid={`menu-tile-${collection.slug}`}
      className="group relative block bg-ink text-paper overflow-hidden aspect-[4/5] sm:aspect-[3/4]"
    >
      <img
        src={cover.src}
        alt=""
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity duration-700 photo-zoom"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-ink/40 via-ink/20 to-ink/85" />

      <div className="relative z-10 h-full p-6 sm:p-8 flex flex-col justify-between">
        <div className="flex items-start justify-between font-mono text-[0.65rem] sm:text-[0.7rem] tracking-[0.3em] uppercase text-paper/70">
          <span>N° {collection.number}</span>
          <span>{collection.photos.length} {labels.works}</span>
        </div>
        <div>
          <h3 className="font-display font-black text-[2rem] sm:text-[2.6rem] lg:text-[3.2rem] leading-[0.95] text-paper">
            {title}
          </h3>
          <p className="font-display italic text-base sm:text-lg text-paper/80 mt-2">
            {subtitle}
          </p>
          <span className="inline-flex items-center gap-2 mt-4 font-mono text-[0.7rem] tracking-[0.35em] uppercase text-paper/90 group-hover:text-paper transition-colors">
            <span>{labels.open} {String(index + 1).padStart(2, "0")}</span>
            <span className="w-6 h-px bg-paper/60 group-hover:w-10 transition-all" />
          </span>
        </div>
      </div>
    </Link>
  );
}

function ContactStrip({ labels }) {
  return (
    <Link
      to="/contatti"
      data-testid="menu-tile-contatti"
      className="group relative block bg-ink text-paper overflow-hidden mt-4 sm:mt-6"
    >
      <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 p-6 sm:p-10">
        <div>
          <div className="font-mono text-[0.65rem] sm:text-[0.7rem] tracking-[0.3em] uppercase text-paper/60 mb-2">
            N° 04
          </div>
          <h3 className="font-display font-black text-[1.8rem] sm:text-[2.4rem] leading-[0.95] text-paper">
            {labels.contactTitle}
          </h3>
          <p className="font-display italic text-base sm:text-lg text-paper/80 mt-1">
            {labels.contactSub}
          </p>
        </div>
        <span className="inline-flex items-center gap-3 font-mono text-[0.7rem] tracking-[0.35em] uppercase text-paper/90 group-hover:text-paper transition-colors">
          <span>{labels.contactCta}</span>
          <span className="w-8 h-px bg-paper/60 group-hover:w-14 transition-all" />
        </span>
      </div>
    </Link>
  );
}

function MenuTiles() {
  const { lang } = useLang();
  const labels = LABELS[lang] || LABELS.it;
  return (
    <section id="menu" data-testid="menu-tiles" className="max-w-[1400px] mx-auto px-6 sm:px-10 py-20 sm:py-24">
      <div className="flex items-end justify-between mb-10 sm:mb-14">
        <p className="overline">{labels.kicker}</p>
        <p className="hidden sm:block font-mono text-[0.7rem] tracking-[0.35em] uppercase text-muted">
          {labels.hint}
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
        {COLLECTIONS.map((c, i) => (
          <CollectionTile key={c.slug} collection={c} labels={labels} index={i} />
        ))}
      </div>
      <ContactStrip labels={labels} />
    </section>
  );
}

export default MenuTiles;
